// removed by extract-text-webpack-plugin
module.exports = {"svg":"svg___3AwTD","spinner":"spinner___3R7PL","incidenceFeature":"incidenceFeature___22n6_","descriptionFeature":"descriptionFeature___2VtcA","deleteFeature":"deleteFeature___zDw-V"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FormMap/FeatureMessage.module.scss
// module id = 2103
// module chunks = 0